import { Reveal } from "@/lib/motion";

const TEXTURE =
  "https://images.pexels.com/photos/8092437/pexels-photo-8092437.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const Problem = () => {
  return (
    <section className="relative py-28 lg:py-40 overflow-hidden">
      <img
        src={TEXTURE}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover opacity-[0.08]"
      />
      <div className="absolute inset-0 bg-[#050914]/70" />
      <div className="relative max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal>
          <span className="kicker">The Problem</span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-head font-black tracking-tight leading-[1.05] text-[#F8FAFC] text-4xl sm:text-5xl lg:text-6xl mt-6 max-w-4xl">
            Meeting a stranger at an empty property{" "}
            <span className="text-[#D4AF37]">shouldn't feel like a gamble.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-body text-[#CBD5E1] text-lg lg:text-xl leading-relaxed mt-8 max-w-2xl">
            Agents show homes alone every day. Companies have licensed officers ready to work.
            BodyGuard EXP connects the two — instantly, safely, and on your terms.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
